import { defaultUnderlineStyle } from "@ecco/ui/css/common";

const column = "column" as const;
const row = "row" as const;
const relative = "relative" as const;
const wrap = "wrap" as const;
const spaceBetween = "space-between" as const;

export const styles = {
    membershipInfoContainer: {
        borderBottom: "1px solid gray",
    },
    memberOnlybenefitsItemContainer: {
        borderColor: "gray.100",
    },
    membershipCardContainer: {
        backgroundColor: "white",
        display: "flex",
        flexDirection: column,
        paddingBottom: 30,
    },
    memberShipPassMobileContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: "84px",
    },
    memberShipPassMobileButton: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...defaultUnderlineStyle,
    },
    membershipPointsContainer: {
        padding: 25,
        display: "flex",
        flexDirection: column,
        gap: 40,
    },
    membershipPointsInnerContainer: {
        display: "flex",
        flexDirection: row,
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: wrap,
        gap: 9,
    },
    tierLevelInfoContainer: {
        display: "flex",
        flexDirection: column,
        alignItems: "left",
    },
    eccoPassContainer: {
        position: relative,
        backgroundColor: "white",
        padding: 5,
    },
    eccoPassContent: {
        paddingTop: 50,
        paddingBottom: 30,
        paddingLeft: 10,
        paddingRight: 10,
        display: "flex",
        flexDirection: column,
        alignItems: "center",
        justifyContent: "center",
    },
    barCodeContainer: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        maxWidth: "300px",
        marginTop: 2,
    },
    tierLevelLink: {
        display: "flex",
        justifyContent: "start",
        alignItems: "start",
        ...defaultUnderlineStyle,
    },
    nextTier: {
        display: "flex",
        flexDirection: column,
        gap: 2,
    },
    buttonsContainer: { display: "flex", flexDirection: column, gap: 4 },
    balanceHistoryModal: {
        balanceTitleContainer: {
            display: "flex",
            flexDirection: column,
            gap: 4,
        },
        balanceRowContainer: {
            flexDirection: column,
            gap: 4,
            paddingBottom: 15,
        },
        balanceDetailsContainer: {
            display: "flex",
            flexDirection: row,
            justifyContent: spaceBetween,
        },
    },
};
